<template>
  <rv-currency :name="name" :label="label" :validation-rule="validationRule" v-model="data" v-on:input="update"/>
</template>

<script>
import RvCurrency from '../RvCurrency'

export default {
  props: ['value'],
  inject: ['$validator'],
  components: {
    RvCurrency
  },
  data() {
    return {
      label: 'Please enter the total ongoing/recurrent fees in dollars',
      name: 'ongoing-fee',
      validationRule: {
        required: true
      },
      data: this.value
    }
  },
  methods: {
    update: function() {
      this.$emit('input', this.data)
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/modules/inputs/ongoing-fees/OngoingFee.vue